import { Icon } from '@kizen/kds/Icon';
import { Spacer } from '@kizen/kds/Spacer';
import { Tooltip, useTooltip } from '@kizen/kds/Tooltip';
import { Typography } from '@kizen/kds/Typography';
import Switch from '__components/Kizen/Switch';
import BasicModal from '__components/Modals/presets/BasicModal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const EditRowModal = (props: any) => {
  const { show } = props;
  const { t } = useTranslation();
  const [checked, setChecked] = useState(props.fullHeightBlocks ?? false);
  const { triggerProps, tooltipProps, targetProps, showTooltip } =
    useTooltip(true);

  if (!show) {
    return null;
  }

  return (
    <BasicModal
      {...props}
      heading={t('Edit Row')}
      actionBtnColor="green"
      buttonText={t('Save')}
      displayFlex
      onConfirm={() => {
        props.onConfirm(checked);
      }}
    >
      <div className="flex w-full">
        <div>
          <div className="flex items-center">
            <Typography>{t('Full Height Blocks')}</Typography>
            <Spacer mode="vertical" size={10} />
            <span {...triggerProps} {...targetProps}>
              <Icon icon="message-info-circle" size="sm" />
              {showTooltip ? (
                <Tooltip
                  position="right"
                  text={t(
                    'Expandable components will automatically expand to match the tallest column height.'
                  )}
                  modalCompatibility
                  {...tooltipProps}
                />
              ) : null}
            </span>
          </div>
          <Spacer mode="horizontal" size={25} />
          <Switch
            removeMargin
            checked={checked}
            onChange={(ev) => {
              setChecked(ev.target.checked);
            }}
          />
        </div>
      </div>
    </BasicModal>
  );
};
